module.exports = __webpack_public_path__ + "static/07_Deloitte-4d1347885ab22bd9d5aec6216122366f.png";